<template>
  <div class="job-components">
    <div class="job">
      <div class="target-wrapper" id="target01">
        <p class="message-title">
          向いている仕事がわからない方へ。
        </p>
        <div class="reason-wrapper">
          <div class="main-message mincho">
            「横浜、川崎、湘南、町田、<br>
            八王子、多摩あたりで<br>
            いつまでも遊んでいたい」<br>
            と思いませんか。
          </div>
          <div class="reason-image">
            <img src="../assets/img/job/index/image.png" alt="平日、仲間と飲んで、翌日は遅番で出社・30代で家を買った・たとえば、朝イチで海へ 休日も海へ" width="507px">
          </div>
        </div>
        <div class="area-wrapper">
          <div class="area-message">
            そんな毎日を選びませんか？<br>
            勤務地で仕事を選びませんか？<br>
            sanwaは、超エリア限定。<br>
            神奈川・東京以外の異動は<br class="under_display">ありません。
          </div>
          <div class="arrow">
            <img src="../assets/img/job/index/arrow_right.svg" alt="" width="20px">
            <img src="../assets/img/job/index/arrow_down.svg" alt="" width="120px">
          </div>
          <div class="area-list">
            ＜ 勤務地一覧 ＞<br>
            神奈川／ 横浜、川崎、相模原、<br class="under_display">厚木、湘南、藤沢、平塚、座間、<br class="under_display">横須賀<br>
            東京／ 町田、八王子、多摩、稲城、日野、狛江
          </div>
        </div>
      </div>
      <div class="target-wrapper" id="target02">
        <p class="message-title">
          興味をもった仕事がある方へ。
        </p>
        <div class="main-message mincho">
          勤めてみたい部門を<br class="under_display">教えてください。<br>
          あなたの希望を伺って<br class="under_display">配属を決定します。
        </div>
        <div class="department-wrapper">
          <DepartmentLinkCard Link="/job/customer" :image="require('../assets/img/job/index/genre01.jpg')" title="お客様係" mainCatch="接した人に笑顔を。<br>受付として店舗の<br>ムードをつくってます。" />
          <DepartmentLinkCard Link="/job/souzai" :image="require('../assets/img/job/index/genre02.jpg')" title="惣菜" mainCatch="1日の半分以上は、<br>黒子として集中する。<br>接客は少なめです。" />
          <DepartmentLinkCard Link="/job/grocery" :image="require('../assets/img/job/index/genre03.jpg')" title="グロサリー" mainCatch="店舗の中心で、<br>棚をカラフルに彩る。<br>人と世の中に敏感です。" />
          <DepartmentLinkCard Link="/job/nousan" :image="require('../assets/img/job/index/genre04.jpg')" title="農産" mainCatch="春夏秋冬を<br>色とボリュームで演出。<br>お客様を迎えています。" />
          <DepartmentLinkCard Link="/job/suisan" :image="require('../assets/img/job/index/genre05.jpg')" title="水産" mainCatch="魚と対話する。<br>メンバーを動かす。<br>職人のような社員です。" />
          <DepartmentLinkCard Link="/job/chikusan" :image="require('../assets/img/job/index/genre06.jpg')" title="畜産" mainCatch="戦略を立てて、<br>人気食材をもり立てる。<br>知力で勝負しています。" />
          <DepartmentLinkCard Link="/job/nippai" :image="require('../assets/img/job/index/genre07.jpg')" title="日配" mainCatch="食卓の名脇役に光を。<br>常連さんと、あれこれ<br>盛り上がる毎日です。" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DepartmentLinkCard from '@/components/job/DepartmentLinkCard.vue'
export default {
  name: 'Job',
  components: {
    DepartmentLinkCard
  },
}
</script>
<style scoped lang="scss">
.job {
  padding-top: 150px;
  padding-bottom: 100px;
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
  @media print, screen and (max-width: 960px) {
    width: 90%;
    padding-top: 50px;
  }
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.target-wrapper + .target-wrapper {
  margin-top: 150px;
  @media print, screen and (max-width: 960px) {
    margin-top: 75px;
  }
}
.message-title {
  background-color: #e51c57;
  color: #fff;
  text-align: center;
  max-width: 380px;
  width: 100%;
  font-size: 14px;
  margin-bottom: 50px;
}
.reason-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.main-message {
  font-size: 28px;
  line-height: 2em;
  @media print, screen and (max-width: 960px) {
    font-size: 21px;
  }
}
.area-wrapper {
  background-color: #898989;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;
  align-items: center;
  font-size: 17px;
  justify-content: space-between;
  border-radius: 5px;
  margin-top: 50px;
  @media print, screen and (max-width: 960px) {
    flex-direction: column;
  }
  .arrow {
    margin: 0 auto;
    img:nth-child(1) {
      @media print, screen and (max-width: 960px) {
        display: none;
      }
    }
    img:nth-child(2) {
      margin: 20px 0;
      @media print, screen and (min-width: 961px) {
        display: none;
      }
    }
  }
}
.department-wrapper {
  margin-top: 80px;
  display: grid;
  grid-template-columns: repeat(auto-fit, 470px);
  justify-content: center;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  @media print, screen and (max-width: 460px) {
    grid-template-columns: repeat(auto-fit, 100%);
  }
}
@media all and (-ms-high-contrast: none) { //ie11ハック
  .department-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}
</style>
